(function () {
  var cfg = window.KAMELY_CHECKOUT;
  if (!cfg || !cfg.apiBase || !cfg.storeSlug) return;

  var PENDING_KEY = 'kamely_shopify_pending_session';
  var TRACKING_KEY = 'kamely_shopify_url_params';
  var SKIP_QUERY_KEYS = { kamely_paid: 1, kamely_session: 1 };
  var SCRIPT_VERSION = '2.2.0-skip-cart';
  var skipCartEnabled = cfg.skipCart === true || cfg.skipCart === 'true' || cfg.skipCart === 1;

  function apiBase() {
    var base = String(cfg.apiBase);
    if (base.charAt(base.length - 1) === '/') base = base.slice(0, -1);
    return base;
  }

  function apiUrl(trackingParams) {
    var base = apiBase() + '/lke/' + encodeURIComponent(cfg.storeSlug) + '/shopify-cart';
    if (!trackingParams || !Object.keys(trackingParams).length) return base;
    try {
      var u = new URL(base);
      Object.keys(trackingParams).forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (trackingParams[k] != null && trackingParams[k] !== '') {
          u.searchParams.set(k, trackingParams[k]);
        }
      });
      return u.toString();
    } catch (e) {
      return base;
    }
  }

  /** Garante tracking na URL do checkout mesmo se a API só devolver return_url. */
  function buildFinalCheckoutUrl(checkoutUrl, trackingParams) {
    if (!checkoutUrl) return checkoutUrl;
    var params = trackingParams || {};
    if (!Object.keys(params).length) return checkoutUrl;
    try {
      var u = new URL(checkoutUrl);
      var returnUrl = u.searchParams.get('return_url');
      u.searchParams.delete('return_url');
      Object.keys(params).forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (params[k] != null && params[k] !== '') u.searchParams.set(k, params[k]);
      });
      if (returnUrl) u.searchParams.set('return_url', returnUrl);
      return u.toString();
    } catch (e) {
      return appendParamsToUrl(checkoutUrl, params);
    }
  }

  function statusUrl(sessionId) {
    return apiBase() + '/lke/shopify-cart-status/' + encodeURIComponent(sessionId);
  }

  function rememberPendingSession(sessionId) {
    try {
      if (sessionId) localStorage.setItem(PENDING_KEY, String(sessionId));
    } catch (e) {}
  }

  function mergeParams() {
    var out = {};
    for (var i = 0; i < arguments.length; i++) {
      var src = arguments[i];
      if (!src || typeof src !== 'object') continue;
      Object.keys(src).forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (src[k] != null && src[k] !== '') out[k] = String(src[k]);
      });
    }
    return out;
  }

  function collectPageQueryParams() {
    var params = new URLSearchParams(window.location.search);
    var out = {};
    params.forEach(function (val, key) {
      if (SKIP_QUERY_KEYS[key]) return;
      if (val != null && val !== '') out[key] = val;
    });
    return out;
  }

  function persistTrackingFromPage() {
    var current = collectPageQueryParams();
    if (!Object.keys(current).length) return;
    try {
      var stored = {};
      try { stored = JSON.parse(sessionStorage.getItem(TRACKING_KEY) || '{}'); } catch (e) {}
      sessionStorage.setItem(TRACKING_KEY, JSON.stringify(mergeParams(stored, current)));
    } catch (e) {}
  }

  function getAllTrackingParams() {
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem(TRACKING_KEY) || '{}'); } catch (e) {}
    return mergeParams(stored, collectPageQueryParams());
  }

  function appendParamsToUrl(baseUrl, extraParams) {
    if (!baseUrl || !extraParams) return baseUrl;
    var keys = Object.keys(extraParams);
    if (!keys.length) return baseUrl;
    try {
      var u = new URL(baseUrl);
      keys.forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (extraParams[k] != null && extraParams[k] !== '') {
          u.searchParams.set(k, extraParams[k]);
        }
      });
      return u.toString();
    } catch (e) {
      var sep = baseUrl.indexOf('?') >= 0 ? '&' : '?';
      var qs = new URLSearchParams();
      keys.forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (extraParams[k] != null && extraParams[k] !== '') qs.set(k, extraParams[k]);
      });
      return baseUrl + sep + qs.toString();
    }
  }

  async function clearShopifyCart() {
    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      });
    } catch (e) {
      console.warn('[Kamely Checkout] cart/clear.js', e);
    }
  }

  async function clearCartIfSessionPaid(sessionId) {
    if (!sessionId) return false;
    try {
      var res = await fetch(statusUrl(sessionId), { credentials: 'omit' });
      var json = await res.json().catch(function () { return {}; });
      if (json.success && json.data && json.data.paid) {
        await clearShopifyCart();
        try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
        return true;
      }
    } catch (e) {
      console.warn('[Kamely Checkout] status', e);
    }
    return false;
  }

  async function handleReturnFromCheckout() {
    var params = new URLSearchParams(window.location.search);
    var paid = params.get('kamely_paid');
    var sessionId = params.get('kamely_session');
    if (paid === '1' && sessionId) {
      var cleared = await clearCartIfSessionPaid(sessionId);
      if (cleared) {
        params.delete('kamely_paid');
        params.delete('kamely_session');
        var next = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', next);
        }
      }
      return;
    }
    var pending = null;
    try { pending = localStorage.getItem(PENDING_KEY); } catch (e) {}
    if (pending) await clearCartIfSessionPaid(pending);
  }

  /** Envia linhas para a API Kamely e redireciona (ou abre em nova aba) para o checkout */
  async function redirectToKamelyWithLines(lines, openInNewTab) {
    if (!lines || !lines.length) return;
    try {
      var pageParams = getAllTrackingParams();
      var res = await fetch(apiUrl(pageParams), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lines: lines,
          url_params: pageParams,
          page_url: window.location.href,
          page_search: window.location.search
        })
      });
      var json = await res.json().catch(function () { return {}; });
      var checkoutUrl = json.data && json.data.checkout_url;
      var txId = json.data && json.data.txId;
      if (json.success && checkoutUrl) {
        var serverParams = (json.data && json.data.url_params) || {};
        var allParams = mergeParams(serverParams, pageParams);
        checkoutUrl = buildFinalCheckoutUrl(checkoutUrl, allParams);
        if (txId) rememberPendingSession(txId);
        if (openInNewTab) {
          window.open(checkoutUrl, '_blank');
        } else {
          window.location.href = checkoutUrl;
        }
        return;
      }
      var msg = (json.errors && json.errors[0] && json.errors[0].message) || json.message || 'Erro ao abrir checkout Kamely.';
      alert(msg);
    } catch (err) {
      console.error('[Kamely Checkout]', err);
      alert(err.message || 'Erro ao iniciar checkout Kamely.');
    }
  }

  async function redirectToKamely(ev) {
    if (ev) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
    }
    try {
      var cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartRes.ok) throw new Error('Não foi possível ler o carrinho.');
      var cart = await cartRes.json();
      var lines = (cart.items || []).map(function (item) {
        return { variant_id: item.variant_id, quantity: item.quantity };
      });
      await redirectToKamelyWithLines(lines);
    } catch (err) {
      console.error('[Kamely Checkout]', err);
      alert(err.message || 'Erro ao iniciar checkout Kamely.');
    }
  }


  /**
   * Skip Cart: intercepta o SUBMIT do formulário de "Adicionar ao carrinho".
   * Interceptar o submit (não o click) é mais confiável porque garante que
   * qualquer handler de click do tema Shopify já foi cancelado pelo preventDefault.
   */
  async function handleSkipCartSubmit(ev) {
    ev.preventDefault();
    ev.stopImmediatePropagation();
    ev.stopPropagation();

    var form = ev.currentTarget || ev.target;

    // Coleta variant_id e quantity do formulário
    var variantInput = form.querySelector('[name="id"]') || form.querySelector('[name="variant_id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = variantInput ? String(variantInput.value).trim() : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    if (!variantId) {
      console.warn('[Kamely Checkout] skip_cart: variant_id não encontrado no form.');
      // Fallback: lê o carrinho atual e redireciona via fluxo normal
      return redirectToKamely(null);
    }

    // Feedback visual: desabilita o botão submit durante o carregamento
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"], button[name="add"]');
    var originalText = submitBtn ? (submitBtn.textContent || submitBtn.value) : null;
    if (submitBtn) {
      submitBtn.disabled = true;
      if (submitBtn.textContent !== undefined) submitBtn.textContent = '...';
      else submitBtn.value = '...';
    }

    try {
      await redirectToKamelyWithLines([{ variant_id: variantId, quantity: qty }], true);
    } finally {
      // Restaura o botão após o redirect (ou erro)
      if (submitBtn) {
        submitBtn.disabled = false;
        if (originalText !== null) {
          if (submitBtn.textContent !== undefined) submitBtn.textContent = originalText;
          else submitBtn.value = originalText;
        }
      }
    }
  }

  var CHECKOUT_SELECTORS = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href*="/checkouts/"]',
    '.cart__checkout-button',
    '#checkout',
    '#CartDrawer-Checkout',
    '[data-cart-checkout]',
    'form[action="/cart"] button[type="submit"]'
  ];

  // Seletores dos FORMULÁRIOS de adicionar ao carrinho (skip_cart)
  var ADD_TO_CART_FORM_SELECTORS = [
    'form[action="/cart/add"]',
    'form[action*="/cart/add"]',
    'form[data-type="add-to-cart-form"]',
    '[data-product-form]'
  ];

  function bindCheckoutButtons() {
    CHECKOUT_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.kamelyCheckoutBound === '1') return;
        el.dataset.kamelyCheckoutBound = '1';
        el.addEventListener('click', redirectToKamely, true);
      });
    });

    if (skipCartEnabled) {
      // Intercepta o submit do form (mais confiável que o click no botão)
      ADD_TO_CART_FORM_SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (form) {
          if (form.dataset.kamelySkipCartBound === '1') return;
          form.dataset.kamelySkipCartBound = '1';
          form.addEventListener('submit', handleSkipCartSubmit, true);
        });
      });
    }
  }


  function initKamelyCheckout() {
    try { console.info('[Kamely Checkout]', SCRIPT_VERSION, skipCartEnabled ? '| skip_cart: ON' : ''); } catch (e) {}
    persistTrackingFromPage();
    bindCheckoutButtons();
    handleReturnFromCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKamelyCheckout);
  } else {
    initKamelyCheckout();
  }
  document.addEventListener('cart:updated', bindCheckoutButtons);
  document.addEventListener('shopify:section:load', bindCheckoutButtons);
  try {
    new MutationObserver(bindCheckoutButtons).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  } catch (e) {}
})();
